import React from "react";
import {
  Dialog,
  Box,
  IconButton,
  Tooltip,
  CircularProgress,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";

export default function PhotoLightbox({
  open,
  photos = [],
  currentIndex = 0,
  onClose,
  onNext,
  onPrev,
  onDelete, // <-- optional delete handler
  isProcessing = false, // <-- optional loader flag
}) {
  if (!photos.length) return null;

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <Box
        sx={{
          position: "relative",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "black",
        }}
      >
        {/* Close */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 20, right: 20, color: "white" }}
        >
          <CloseIcon />
        </IconButton>

        {/* Delete */}
        {onDelete && (
          <Tooltip title="Delete photo">
            <IconButton
              onClick={() => onDelete(photos[currentIndex])}
              sx={{
                position: "absolute",
                top: 20,
                left: 20,
                color: "white",
                bgcolor: "rgba(0,0,0,0.5)",
                "&:hover": { bgcolor: "#c62828" },
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}

        {/* Prev */}
        <IconButton
          onClick={onPrev}
          sx={{ position: "absolute", left: 20, color: "white" }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* Image */}
        <img
          src={photos[currentIndex]?.url}
          alt="Full View"
          style={{
            maxWidth: "90%",
            maxHeight: "90%",
            borderRadius: "10px",
          }}
        />

        {/* Next */}
        <IconButton
          onClick={onNext}
          sx={{ position: "absolute", right: 20, color: "white" }}
        >
          <ArrowForwardIosIcon />
        </IconButton>

        {/* PROCESSING OVERLAY */}
        {isProcessing && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              bgcolor: "rgba(0,0,0,0.65)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
              backdropFilter: "blur(4px)",
              color: "white",
            }}
          >
            <CircularProgress color="inherit" size={55} />
            <Typography sx={{ mt: 2, fontWeight: 500 }}>
              Please wait...
            </Typography>
          </Box>
        )}
      </Box>
    </Dialog>
  );
}
